"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefinable = void 0;
const getDefinables_1 = require("./getDefinables");
const getDefinable = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- The args are not relevant to this function.
prototype, id) => {
    const definable = (0, getDefinables_1.getDefinables)(prototype).get(id);
    if (typeof definable === "undefined") {
        throw new Error(`${prototype.name} "${id}" does not exist.`);
    }
    return definable;
};
exports.getDefinable = getDefinable;
